export default "__VITE_ASSET__wYVw71Hg__"